export default __webpack_public_path__ + "static/media/security.cb57d00b.jpg";